import cn from 'classnames'
import React, { ComponentProps } from 'react'

type CloseIconProps = {
  className?: string
} & ComponentProps<'svg'>

export default function CloseIcon(props: CloseIconProps) {
  const { className = '', ...rest } = props

  return (
    <svg
      className={cn('CloseIcon', className)}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="4.5 4.5 16 16"
      fill="none"
      {...rest}
    >
      <path
        stroke={props.stroke || 'currentColor'}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="m12.5 12.5 4.243-4.243L12.5 12.5 8.257 8.257 12.5 12.5Zm0 0-4.243 4.243L12.5 12.5l4.243 4.243L12.5 12.5Z"
      />
    </svg>
  )
}
